import { workplaceConstants as wc } from 'srcReact/WorkplacePage'

const initialState = {
  ask_access_page: '',
  authorized: false,
  location_search: {},
  new_workplace: {
    submitted: false,
    created: false,
    error: false
  },
  current_workplace: {
    loading: false,
    loaded: false,
    current_user_interests: [],
    info: {},
    team: [],
    users: [],
    groups: [],
    invitations: {
      new: { sending: false },
      alreadyAcceptedEmails: [],
      pending: {
        loading: false,
        list: []
      },
      accepted: {
        loading: false,
        list: []
      },
      pending_expired: {
        loading: false,
        list: []
      },
      draft: {
        loading: false,
        list: []
      },
      requested: {
        loading: false,
        list: [],
        success: false,
        error: ''
      }
    }
  }
}
export function workplace(state = initialState, action) {
  switch (action.type) {
    // Access

    case wc.CAN_ACCESS_CREATE_PAGE_REQUEST:
      return {
        ...state,
        ask_access_page: true,
        authorized: false
      }

    case wc.CAN_ACCESS_CREATE_PAGE_SUCCESS:
      return {
        ...state,
        ask_access_page: false,
        authorized: true
      }

    case wc.CAN_ACCESS_CREATE_PAGE_FAILURE:
      return {
        ask_access_page: false,
        authorized: false
      }

    // New Worplace
    case wc.CREATE_WORKPLACE_REQUEST:
      return {
        ...state,
        new_workplace: { submitted: true, created: false, error: false }
      }
    case wc.CREATE_WORKPLACE_SUCCESS:
      return {
        ...state,
        new_workplace: { submitted: true, created: false, error: false }
      }
    case wc.CREATE_WORKPLACE_FAILURE:
      return {
        ...state,
        new_workplace: { submitted: false, created: false, error: true }
      }

    case wc.APPROVE_INVITATION_REQUEST:
    case wc.REJECT_INVITATION_REQUEST: {
      return {
        ...state,
        current_workplace: {
          ...state.current_workplace,
          invitations: {
            ...state.current_workplace.invitations,
            requested: {
              ...state.current_workplace.invitations.requested,
              loading: true,
              success: false,
              error: ''
            }
          }
        }
      }
    }
    case wc.APPROVE_INVITATION_SUCCESS:
    case wc.REJECT_INVITATION_SUCCESS: {
      const { invitations } = action.response
      const updatedInvitations = state.current_workplace.invitations.requested.list.filter(
        (x) => x.id !== invitations[0].id
      )
      return {
        ...state,
        current_workplace: {
          ...state.current_workplace,
          invitations: {
            ...state.current_workplace.invitations,
            requested: {
              ...state.current_workplace.invitations.requested,
              loading: false,
              list: updatedInvitations,
              success: true,
              error: ''
            }
          }
        }
      }
    }
    case wc.APPROVE_INVITATION_FAILURE: {
      return {
        ...state,
        current_workplace: {
          ...state.current_workplace,
          invitations: {
            ...state.current_workplace.invitations,
            requested: {
              ...state.current_workplace.invitations.requested,
              loading: false,
              success: false,
              error: action.error
            }
          }
        }
      }
    }
    case wc.REJECT_INVITATION_FAILURE: {
      return {
        ...state,
        current_workplace: {
          ...state.current_workplace,
          invitations: {
            ...state.current_workplace.invitations,
            requested: {
              ...state.current_workplace.invitations.requested,
              loading: false,
              success: false,
              error: action.error
            }
          }
        }
      }
    }

    default:
      return state
  }
}
